export type SubmittedKit = {
    Id: number,
    LabID: number,
    OperatorId: number,
    StreckOperator: string,
    LotNumber: number,
    KitVialSize: number,
    KitNumber: number,
    PipetID: number,
    PipetDeliveryVolume: number | undefined,
    UM: string,
    RefractometerSerialNumber: string,
    EmailReportTo: string,
    WaterVolume: number | undefined,
    ValuesUsed: number | undefined,
    Mean: number | undefined,
    MeanPCT: number | undefined,
    SD: number | undefined,
    CV: number | undefined,
    Locked: boolean,
    Review: boolean,
    DateEntered: Date,
    KitStatus: any,
    Barcode: string,
    pipet: any,
    operator: any,
}

export function apiModelToSubmittedKit(apiModel: any) {
    return {
        Id: apiModel.id,
        LabID: apiModel.labId,
        OperatorId: apiModel.operatorId,
        StreckOperator: apiModel.streckOperator,
        LotNumber: apiModel.lotNumber,
        KitNumber: apiModel.kitNumber,
        PipetID: apiModel.pipetId,
        PipetDeliveryVolume: apiModel.pipetDeliveryVolume,
        UM: apiModel.um,
        RefractometerSerialNumber: apiModel.refractometerSerialNumber,
        EmailReportTo: apiModel.emailReportTo,
        KitVialSize: apiModel.kitVialSize,
        WaterVolume: apiModel.waterVolume,
        ValuesUsed: apiModel.valuesUsed,
        Mean: apiModel.mean,
        MeanPCT: apiModel.meanPCT,
        SD: apiModel.sd,
        CV: apiModel.cv,
        Locked: apiModel.locked,
        Review: apiModel.review,
        DateEntered: new Date(apiModel.dateEntered),
        KitStatus: apiModel.kitStatusType,
        Barcode: apiModel.barcode,
        pipet: apiModel.pipet,
        operator: apiModel.operator,
    } as SubmittedKit;
}

export const blankSubmittedKit = {
    Id: 0,
    LabID: 0,
    OperatorId: 0,
    StreckOperator: "",
    LotNumber: 0,
    KitVialSize: 0,
    KitNumber: 0,
    PipetID: 0,
    PipetDeliveryVolume: undefined,
    EmailReportTo: "",
    UM: "U",
    RefractometerSerialNumber: "",
    WaterVolume: undefined,
    ValuesUsed: undefined,
    Mean: 0,
    MeanPCT: 0,
    SD: undefined,
    CV: undefined,
    Locked: false,
    Review: false,
    DateEntered: new Date(),
    Barcode: "",
    pipet: {},
    operator: {},
} as SubmittedKit;
